import axios from "axios";
import toast from "react-hot-toast";
const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const getRankingList = (rankingData) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "GET_RANKING_LIST_REQUEST" });
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.post(
        `${BASE_URL}/builder/ranking-list`,
        rankingData,
        config
      );
      if (data.statusCode === 200) {
        dispatch({ type: "GET_RANKING_LIST_SUCCESS", payload: data });
      } else {
        dispatch({ type: "GET_RANKING_LIST_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "GET_RANKING_LIST_FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};


export const getProjectRankingList = (rankingData) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "GET_PROJECT_RANKING_LIST_REQUEST" });
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.post(
        `${BASE_URL}/project/ranking-list`,
        rankingData,
        config
      );
      if (data.statusCode === 200) {
        dispatch({ type: "GET_PROJECT_RANKING_LIST_SUCCESS", payload: data });
      } else {
        dispatch({ type: "GET_PROJECT_RANKING_LIST_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "GET_PROJECT_RANKING_LIST_FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const updateRanking = (rankingData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "UPDATE_RANKING_REQUEST" });
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.post(
        `${BASE_URL}/builder/update-ranking`,
        rankingData,
        config
      );
      if (data.statusCode === 200) {
        dispatch({ type: "UPDATE_RANKING_SUCCESS", payload: data });
        // toast.success("Ranking Updated Successfully!!");
        return data;
      } else {
        dispatch({ type: "UPDATE_RANKING_FAILED", payload: data });
        // toast.error("Something Went Wrong!!");
      }
    } catch (error) {
      dispatch({
        type: "UPDATE_RANKING_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message);
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const updateProjectRanking = (rankingData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "UPDATE_PROJECT_RANKING_REQUEST" });
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.post(
        `${BASE_URL}/project/update-project-ranking`,
        rankingData,
        config
      );
      if (data.statusCode === 200) {
        dispatch({ type: "UPDATE_PROJECT_RANKING_SUCCESS", payload: data });
        // toast.success("Ranking Updated Successfully!!");
        return data;
      } else {
        dispatch({ type: "UPDATE_PROJECT_RANKING_FAILED", payload: data });
        // toast.error("Something Went Wrong!!");
      }
    } catch (error) {
      dispatch({
        type: "UPDATE_PROJECT_RANKING_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message);
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};



export const getProjectVideoRankingList = (rankingData) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "GET_PROJECT_VIDEO_RANKING_LIST_REQUEST" });
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.post(
        `${BASE_URL}/project/video-ranking-list`,
        rankingData,
        config
      );
      if (data.statusCode === 200) {
        dispatch({ type: "GET_PROJECT_VIDEO_RANKING_LIST_SUCCESS", payload: data });
      } else {
        dispatch({ type: "GET_PROJECT_VIDEO_RANKING_LIST_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "GET_PROJECT_VIDEO_RANKING_LIST_FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const updateProjectVideoRanking = (rankingData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "UPDATE_PROJECT_VIDEO_RANKING_REQUEST" });
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.post(
        `${BASE_URL}/project/update-project-video-ranking`,
        rankingData,
        config
      );
      if (data.statusCode === 200) {
        dispatch({ type: "UPDATE_PROJECT_VIDEO_RANKING_SUCCESS", payload: data });
        return data;
      } else {
        dispatch({ type: "UPDATE_PROJECT_VIDEO_RANKING_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "UPDATE_PROJECT_VIDEO_RANKING_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message);
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};